<template>
  <div class="load">
    <div class="forms white reverse theme">
      <!-- toolbar -->
      <div class="medium normal row pb-1 pt-2 pl-1">
        <img
          class="logotype ml-2"
          src="https://res.cloudinary.com/complex-software/image/upload/v1592522281/Springboard/desktop/jktrdx6efeftifgvuvmy.png"
        />
        <div class="mt-1 ml-1">Springboard</div>
      </div>

      <!-- inputs -->
      <transition name="fade-left" mode="out-in">
        <router-view v-if="animation" />
      </transition>
    </div>

    <!-- EFECTS -->

    <transition name="fade-up" mode="out-in">
      <div v-if="animation" class="circle-1 primary"></div>
    </transition>

    <transition name="fade-down" mode="out-in">
      <div v-if="animation" class="circle-2 primary"></div>
    </transition>

    <div class="hide-movil primary spacer">
      <transition name="fade-up-slow" mode="out-in">
        <div v-if="animation" class="circle-2-2 accent"></div>
      </transition>

      <transition-group name="fade-right" mode="out-in">
        <div key="0" v-if="animation" class="cutter">
          <div class="circle accent"></div>
        </div>
        <div key="1" v-if="animation" class="circle-4 circle white">
          <div class="reverse medium letters">
            <div class="pl-1">
              Obtén tu
              <br />Propia e
              <br />Increíble
              <br />Aplicación
            </div>
          </div>
        </div>

        <img
          key="3"
          v-if="animation"
          class="img-effect"
          src="https://res.cloudinary.com/complex-software/image/upload/v1592511961/Springboard/desktop/qhxtgo1c08ecj4w9sp8z.png"
        />
      </transition-group>

      <transition name="fade-down" mode="out-in">
        <div v-if="animation" class="circle-3 accent"></div>
      </transition>

      <div
        class="copy theme body-2 center-text"
      >©2020 Complex Software Intellectual Property. Springboard, el logotipo de Springboard, y todas las otras marcas de Springboard contenidas aquí son marcas comerciales de Complex Software Intellectual Property y/o compañías afiliadas de Complex Software</div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    setTimeout(() => {
      this.animation = true;
    }, 100);
  },
  data: () => ({
    animation: false
  })
};
</script>
<style scoped>
.copy {
  position: fixed;
  top: 94vh;
  z-index: 500;
  right: 2.5%;
  width: 65%;
}
.letters {
  font-size: 4.3vw;
  line-height: 4.2vw;
  position: relative;
  top: 6vw;
  left: 5.4vw;
}
.logotype {
  margin-top: 5px;
  height: 19px;
  width: 19px;
}
.load {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}

.circle-1 {
  border-radius: 50%;
  position: fixed;
  height: 65vw;
  width: 65vw;
  opacity: 0.85;
  top: 80vh;
  left: -15vw;
  z-index: 100;
}

.circle-2 {
  border-radius: 50%;
  position: fixed;
  height: 10vw;
  width: 10vw;
  top: 2vh;
  opacity: 0.7;
  left: 25vw;
  z-index: 100;
}

.circle-2-2 {
  border-radius: 50%;
  position: fixed;
  height: 20vw;
  width: 20vw;
  top: 65vh;
  left: 32vw;
  opacity: 0.3;
  z-index: 50;
}

.circle-3 {
  border-radius: 50%;
  position: fixed;
  height: 60vw;
  width: 60vw;
  top: -40vh;
  right: 2vw;
  opacity: 0.8;
  z-index: 0;
}

.circle-4 {
  position: fixed;
  top: 25vh;
  z-index: 100;
  left: 68.7vw;
}

.circle {
  border-radius: 50%;
  height: 30vw;
  width: 30vw;
}

.cutter {
  z-index: 300;
  width: 4vw;
  overflow: hidden;
  position: fixed;
  height: 60vh;
  top: 25vh;
  left: 68.7vw;
  opacity: 0.8;
}

.forms {
  width: 30%;
}

.img-effect {
  position: fixed;
  top: 5.5vh;
  right: 23.3vw;
  width: 26vw;
  z-index: 200;
}

@media only screen and (max-width: 768px) {
  .hide-movil {
    display: none;
  }
  .forms {
    width: 100%;
  }
  .circle-1 {
    border-radius: 50%;
    position: fixed;
    height: 120vw;
    width: 120vw;
    opacity: 0.9;
    top: 80vh;
    left: -30vw;
    z-index: 100;
  }
  .circle-2 {
    border-radius: 50%;
    position: fixed;
    height: 50vw;
    width: 50vw;
    top: -12vh;
    opacity: 0.9;
    left: 70vw;
    z-index: 100;
  }
}
</style>